<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-flod-content search-content common-search-formtype" style="padding: 0;border: none">
          <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
            <el-form-item label="输入搜索:">
              <el-input v-model="formInlineTmp.salesman" placeholder="请输入申请人姓名/手机号" clearable></el-input>
            </el-form-item>
            <el-form-item label="申请时间:" style="margin-bottom: 0;">
              <el-date-picker
                class="micro-page-picker"
                style="width:350px!important;margin-top: 14px"
                v-model="timePickerDate"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @blur="verifyTime"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="margin-top: 20px;border-bottom: 1px solid #e7e7e7; padding-right: 0px;">
      <el-col :span="12" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">{{ activity_name }}-申请列表</span>
      </el-col>
      <el-col :span="12" class="text-align-right">
        <el-button type="primary" class="search-btn-new" @click="downloadCustomer">导出</el-button>
          <!--<el-button type="primary" @click="addOfflineAcivityAction" class="add-btn" style="float: right;">分配</el-button>-->
      </el-col>
    </el-row>
    <el-row class="import-data-title">
      <el-table
        :data="tableData"
        class="table activity">
        <el-table-column
          :label="item.label"
          v-for="(item, index) in headerList"
          :key="index"
          :prop="item.value"
          :width="(item.label === '申请时间') ? '180':''">
           <template slot-scope="scope">
            <div v-if="item.label === '场次名称'" class="activity-name">
              <el-popover trigger="hover" placement="top">
                {{ scope.row[item.value] }}
                <div slot="reference" class="name-wrapper">
                  <a :href="'/home/offline-acitivity-statistics?id=' + scope.row.id" class="link">{{ scope.row[item.value] }}</a>
                </div>
              </el-popover>
            </div>
            <div v-else>{{ scope.row[item.value] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新建弹窗-->
      <el-dialog class="cellDialog base-dialog" title="分配二维码" :visible.sync="QrcodeDialog" width="540px">
        <el-form :inline="true" :model="form" ref="form" :rules="rules" label-width="90px">
          <el-form-item label="二维码名称:" prop="qrcode_name">
            <el-input v-model="form.qrcode_name" placeholder="请输入二维码名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="业务员:" prop="saleman_id">
            <el-select v-model="form.salesman_id" placeholder="请选择">
              <el-option
                v-for="item in salesmanOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button class="dialog-cancel-btn" @click="QrcodeDialog = false">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" :disabled="isDisabled" @click="submitForm('form')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 二维码弹窗-->
      <el-dialog class="cellDialog base-dialog" title="二维码" :visible.sync="QRViewDialog" width="500px">
         <img :src="QRImage" style="width: 300px; height: 300px;">
         <!--<qriously :value="QRImage" style="margin: 0 auto;text-align: center" :size="300"/>-->
         <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
            <el-button class="dialog-cancel-btn" @click="QRViewDialog = false" style="margin-left: 20px" >关闭</el-button>
            </div> -->
      </el-dialog>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { exportActivityCountList, getqrcodeActivityList, getStructureList, getSalesmanList, deleteActivityList, addActivityQrcode, activityApplyTotal } from '@/api/customer.js'
export default {
  name: 'activityCountList',
  data () {
    return {
      formInlineTmp: {},
      headerList: [],
      QrcodeDialog: false,
      QRViewDialog: false,
      isDisabled: false,
      QRImage: '',
      activity_name: '',
      activity_id: 0,
      public_id: 0,
      addGradeDialog: false,
      formInline: {},
      form: {
        qrcode_name: '',
        salesman_id: ''
      },
      qrcode_name: '',
      salesman_id: '',
      search: {
        keyword: '',
        qrcode_name: '',
        structure_name: ''
      },
      search_saleman: {
        public_id: 0
      },
      structureOptions: [],
      salesmanOptions: [],
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      inGradeList: [],
      isSwitchClick: 1,
      timePickerDate: [],
      rules: {
        qrcode_name: [
          { required: true, message: '请输入二维码名称', trigger: 'blur' }
        ],
        saleman_name: [
          { required: true, message: '请选择业务员', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 判断开始结束时间大小
    verifyTime() {
      if (Date.parse(new Date(this.timePickerDate[0])) > Date.parse(new Date(this.timePickerDate[1]))) {
        _g.toastMsg('error', '开始时间不能晚于结束时间')
      }
    },
    searchData() {
      this.page = 1
      if (this.timePickerDate === null) {
        this.formInlineTmp.starttime = ''
        this.formInlineTmp.endtime = ''
      } else {
        this.formInlineTmp.starttime = this.timePickerDate[0]
        this.formInlineTmp.endtime = this.timePickerDate[1]
      }
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.loadData()
    },
    addOfflineAcivityAction() {
      this.QrcodeDialog = true
    },
    deleteActivity(id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteActivityList(id).then(res => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
            this.loadData()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      })
    },
    checkStaticsManage(Id, activity_id) {
      router.push({path: '/home/activity-count-details', query: {id: Id, activity_id: activity_id}})
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.loadData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.loadData()
    },
    // 打开看二维码大图
    showQRcode(url) {
      this.QRViewDialog = true
      this.QRImage = url
    },
    // 导出
    downloadCustomer() {
      if (this.totalCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let id = this.$route.query.id
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      exportActivityCountList(id, this.formInline).then(response => {
        this.download(response)
      }).catch((error) => {
        console.log(error)
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 获取部门数据
    getStructureData() {
      getStructureList().then(res => {
        this.structureOptions.push({
          id: '',
          name: '全部'
        })
        for (let item of res.data.data.list) {
          this.structureOptions.push({
            id: item.id,
            name: item.name
          })
        }
      })
    },
    // 获取业务员
    getSalesmanData(page, search) {
      getSalesmanList(page, this.search_saleman).then(res => {
        for (let item of res.data.data.list) {
          this.salesmanOptions.push({
            id: item.id,
            name: item.realname
          })
        }
        this.loadData()
      })
    },
    // 新建弹窗提交
    submitForm() {
      if (this.form.qrcode_name === '') {
        _g.toastMsg('error', '请输入二维码名称')
        return
      }
      if (this.form.salesman_id === '') {
        _g.toastMsg('error', '请选择业务员')
        return
      }
      this.QrcodeDialog = false
      addActivityQrcode(this.form.qrcode_name, this.form.salesman_id, this.activity_id).then(res => {
        if (res.data.code === 0) {
          this.QrcodeDialog = false
          this.isDisabled = false
          this.form.qrcode_name = ''
          this.form.salesman_id = ''
          _g.toastMsg('success', res.data.error)
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
          console.log(res.error)
        }
      })
    },
    // 列表数据
    loadData() {
      let id = this.$route.query.id
      activityApplyTotal(this.page, this.limit, id, this.formInline.salesman, this.formInline.starttime, this.formInline.endtime).then(res => {
        this.headerList = res.data.data.title
        this.totalCount = res.data.data.total
        this.tableData = res.data.data.list
      })
    }
  },
  created() {
    let limit_salesman = 0
    this.activity_id = this.$route.query.id
    this.formInline.activity_id = this.$route.query.id
    this.search_saleman.public_id = this.$route.query.public_id
    this.activity_name = this.$route.query.activity_name
    this.getStructureData()
    this.loadData()
    this.getSalesmanData(this.page, limit_salesman, this.search_saleman)
  }
}
</script>

<style scoped>
.link {
  color: #1980FF;
  font-size: 12px;
}
.activity-name {
  margin-left: 20px;
}
.table .el-table__header th {
  margin-left: 20px;
}
.name-wrapper {
  width: 100px;
  /*margin-left: 20px;*/
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
}
</style>
